import { Controller } from '@hotwired/stimulus'
import { setupAppKit } from '@/web3/config/onramp.js'

export default class extends Controller {
  static values = {
    chains: Array,
  }

  connect() {
    this.modal = setupAppKit(this.chainsValue)
  }

  show() {
    this.modal.open()
  }

  get chainId() {
    return this.modal.getCaipNetwork().id
  }

  get address() {
    return this.modal.getAddress()
  }

  get isConnected() {
    return this.modal.getIsConnectedState()
  }

  get chain() {
    return this.chainsValue.find((chain) => chain.chain_id === `${this.chainId}`)
  }

  get provider(){
    return this.modal.getWalletProvider()
  }
}
